import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-creative'

import { EffectCreative, Navigation } from 'swiper'
import EnhancementsSlide from 'molecules/enhancementsSlide'
import { CarouselBtn } from 'atoms/buttons'
import { extraClasses } from './carousel'
import { EnhancementsType } from 'utils/eliteTypes'

export type enhancementData = {
  enhancements: EnhancementsType[]
  title: string
  subTitle: string
  extraText?: string
}

const Enhancements = (data: enhancementData) => {
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const { title, enhancements, subTitle, extraText } = data

  const reorderCarouselItems = (items: EnhancementsType[]) => {
    if (!items || items.length === 0) return items

    return [items[items.length - 1], ...items.slice(0, items.length - 1)]
  }

  const carouselData = reorderCarouselItems(enhancements)

  return (
    <>
      {carouselData.length === 0 ? null : (
        <>
          <section className="enhancement-carousel">
            <div className="grid grid-cols-10 gap-x-3 xl:gap-x-10">
              <div
                className="col-start-1 col-end-6 blade-top-padding-sm blade-bottom-padding-sm lg:col-end-5 xl:col-end-6"
                style={{
                  backgroundImage:
                    'linear-gradient( to right, #F1F5F6 , #F1F5F6 55% , white 55%, white )',
                }}
              >
                <div className="blade-top-padding blade-bottom-padding">
                  <div className="pl-14 xl:pl-[10.5%] 2xl:pl-24 pr-6 2xl:pr-20">
                    <div className="grid gap-6 px-3 py-10 rounded-md bg-lightgray md:px-6 xl:px-10 2xl:px-20 xl:py-16 2xl:py-28">
                      <h3 className="font-medium ">{title}</h3>
                      <h5 className="max-w-md font-regular 2xl:pt-4">
                        {subTitle}
                      </h5>
                      <h5 className="max-w-md font-regular text-opacity-80">
                        {carouselData[activeIndex].title}
                      </h5>

                      {extraText && (
                        <h5 className="max-w-md font-regular text-opacity-80">
                          {extraText}
                        </h5>
                      )}
                      <div className="flex gap-4 pt-5 xl:pt-10 xl:gap-6">
                        <CarouselBtn
                          activeIndex={activeIndex}
                          color="black"
                          onClick={() => {}}
                          index={0}
                          text="Move to previous slide"
                          size="base"
                          type="button"
                          extraClasses={
                            extraClasses +
                            ' enhancements-swiper-prev !border-1 !p-4'
                          }
                        />
                        <div className="flex items-center gap-1">
                          <span className="text-xl font-medium text-orange ">
                            0{activeIndex + 1}
                          </span>
                          <span className="text-xl font-medium ">&ndash;</span>
                          <span className="text-xl font-medium ">
                            0{carouselData.length}
                          </span>
                        </div>
                        <CarouselBtn
                          activeIndex={activeIndex}
                          color="black"
                          onClick={() => {}}
                          index={carouselData.length - 1}
                          text="Move to next slide"
                          size="base"
                          type="button"
                          isRotated
                          extraClasses={
                            extraClasses +
                            ' enhancements-swiper-next !border-1 !p-4'
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-start-6 col-end-11 pr-0 blade-top-padding blade-bottom-padding lg:col-start-5 xl:col-start-6 lg:pr-0">
                <div className="h-full blade-top-padding blade-bottom-padding">
                  <div className="flex items-center h-full xl:pl-10 2xl:pl-14">
                    <Swiper
                      initialSlide={0}
                      slidesPerGroup={1}
                      grabCursor={true}
                      speed={500}
                      loop={true}
                      effect={'creative'}
                      preloadImages={true}
                      slidesPerView={1}
                      breakpoints={{
                        768: {
                          slidesPerView: 1.2,
                        },
                        976: {
                          slidesPerView: 1.4,
                        },
                        1024: {
                          slidesPerView: 1.3,
                        },

                        1280: {
                          slidesPerView: 1.5,
                        },
                      }}
                      onSlideChange={(swiper) => {
                        setActiveIndex(swiper.realIndex)
                      }}
                      creativeEffect={{
                        limitProgress: 3,
                        prev: {
                          shadow: false,
                          translate: [0, 0, -300],
                          opacity: 0,
                        },

                        next: {
                          translate: ['110%', 0, 0],
                          opacity: 0.3,
                        },
                      }}
                      modules={[EffectCreative, Navigation]}
                      navigation={{
                        nextEl: '.enhancements-swiper-next',
                        prevEl: '.enhancements-swiper-prev',
                      }}
                      className="cursor-pointer"
                    >
                      {carouselData.map((elem, index: number) => {
                        const key = `${index}`
                        const { title, coverImage, desc } = elem
                        return (
                          <SwiperSlide key={key}>
                            <EnhancementsSlide
                              title={title}
                              coverImage={coverImage}
                              desc={desc}
                            />
                          </SwiperSlide>
                        )
                      })}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  )
}

export default Enhancements
